<template>
	<v-list-item-title v-bind="$attrs" v-on="$listeners">
		<slot></slot>
	</v-list-item-title>
</template>

<script>
export default {
	name: 'KListItemTitle'
};
</script>